const DIGITS_PATTERN = /^\d+$/;

export const parseToPositiveInteger = (
	value: string | null | undefined,
): number | undefined => {
	if (!value || !DIGITS_PATTERN.test(value)) {
		return undefined;
	}
	const parsed = Number(value);
	return Number.isSafeInteger(parsed) && parsed > 0 ? parsed : undefined;
};
